import { fromJS, List, Record } from 'immutable';
import { generateKeys, generateSchema } from '../../utils/helpers/model.helper';

export enum NotificationStateEnum {
  new = 'new',
  seen = 'seen',
  read = 'read',
  dismissed = 'dismissed',
}

export const NOTIFICATION_SCHEMA = Object.freeze({
  ID: '',
  EFFECTIVE_DATE: '', // i2g-date-time (yyyy-mm-dd'T'hh:mm:ssZ)
  STATE: NotificationStateEnum.new,
  MAIN_TEXT: '',
  AUX_TEXT: '',
  ACTION_URL: '',
});
export const RECORD = generateSchema(NOTIFICATION_SCHEMA);
export const KEYS: any = generateKeys(NOTIFICATION_SCHEMA);

export class Notification extends Record(RECORD) {
  static KEYS: any = KEYS;

  static fromJsonList(array: any[]): List<Notification> {
    return List<Notification>(
      array ? array.map((props) => new Notification(props)) : []
    );
  }

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get id(): string {
    return this.get(KEYS.ID);
  }

  get effectiveDate(): string {
    return this.get(KEYS.EFFECTIVE_DATE);
  }

  get state(): NotificationStateEnum {
    return this.get(KEYS.STATE);
  }

  setState(state: NotificationStateEnum): Notification {
    return this.set(KEYS.STATE, state) as Notification;
  }

  get mainText(): string {
    return this.get(KEYS.MAIN_TEXT);
  }

  get auxText(): string {
    return this.get(KEYS.AUX_TEXT);
  }

  get actionUrl(): string {
    return this.get(KEYS.ACTION_URL);
  }

  isNew(): boolean {
    return this.state === NotificationStateEnum.new;
  }

  isSeen(): boolean {
    return this.state === NotificationStateEnum.seen;
  }

  isRead(): boolean {
    return this.state === NotificationStateEnum.read;
  }
}
